import { createSelector } from 'reselect';

const loginSelector = state => state.login;

export const loginErrorSelector = createSelector(
  loginSelector,
  login => login.loginError,
);

export const isAdminSelector = createSelector(
  loginSelector,
  login => login.isAdmin,
);

export const isExceedLoginTimesSelector = createSelector(
  loginSelector,
  login => login.isExceedLoginTimes,
);

export const verifyingTokenErrorsSelector = createSelector(
  loginSelector,
  login => login.verifyingTokenErrors,
);
